<template>
    <div class="row notification-panel" v-if="show">
        <div class="col-12">
            <form autocomplete="off" method="post" data-vv-scope="notification">
                <div class="row">
                    <div class="col-sm">
                        <div class="row">
                            <div class="col-sm">
                                <div class="form-group">
                                    <MaterialSelect
                                        class="city-form-group city-bg mt-0"
                                        id="input-notification"
                                        name="notification"
                                        label="name"
                                        :filterable="true"
                                        @input="onChangeTemplate"
                                        :options="lists.templates"
                                        v-model.trim="form.notification_id">
                                        Template
                                    </MaterialSelect>
                                </div>
                            </div>
                            <div class="col-sm-auto d-flex align-items-center" v-if="lists.channels.length">
                                <div class="form-group">
                                    <label>Canal</label>
                                    <div class="d-flex flex-wrap d-sm-inline-flex flex-sm-wrap">
                                        <div class="form-check city-form-check"
                                            :class="[{'is-invalid': fnHasError(`channels`, 'notification') }]"
                                            :key="`channel-${idx}`"
                                            v-for="channel, idx in lists.channels">
                                            <input class="form-check-input"
                                                type="radio"
                                                v-model="form.channel_id"
                                                :value="channel.id"
                                                :id="`cb-channel-${channel.id}`"
                                                :name="`channels`"
                                                v-validate="{'required': true}">
                                            <label class="form-check-label" :for="`cb-channel-${channel.id}`">
                                                {{ channel.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="lists.targets.length">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Alvos para Notificação</label>
                                    <div class="d-flex flex-wrap d-sm-inline-flex flex-sm-wrap">
                                        <template v-for="target, idx in lists.targets">
                                            <div class="form-check city-form-check"
                                                :class="[{'is-invalid': fnHasError(`targets`, 'notification') }]" :key="idx">
                                                <input class="form-check-input"
                                                    type="checkbox"
                                                    v-model="form.targets"
                                                    :value="target"
                                                    :id="`cb-target-${target.id}`"
                                                    :name="`targets`"
                                                    v-validate="{'required': form.otherTargets ? false : true}">
                                                <label class="form-check-label" :for="`cb-target-${target.id}`">
                                                    {{ target.name }}
                                                </label>
                                            </div>
                                        </template>
                                        <div class="form-check city-form-check"
                                            :class="[{'is-invalid': fnHasError('target-other', 'notification') }]" >
                                            <input class="form-check-input"
                                                type="checkbox"
                                                v-model="form.otherTargets"
                                                :value="form.otherTargets"
                                                id="target-other"
                                                name="target-other"
                                                v-validate="{'required': form.otherTargets || form.targets.length == 0 ? true : false}"
                                                >
                                            <label class="form-check-label" for="target-other">
                                                Outro
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col" v-if="form.otherTargets">
                                <MaterialInput
									type="text"
									class="city-form-group city-bg"
									id="input-contacts"
									name="contacts"
									v-model="form.contacts"
									v-validate="getRule('contacts')"
									:inputClasses="[{'is-invalid': fnHasError('contacts', 'notification') }]"
									:error="fnFirstError('contacts', 'notification')"
									:helpText="`Utilizar '${separatorContacts}' para separar os contatos.`"
								>
									Contatos
								</MaterialInput>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <MaterialInput
										:readonly="!activeSubjectField"
										:disabled="!activeSubjectField"
										type="text"
										class="city-form-group city-bg"
										id="input-subject"
										name="subject"
										v-model="replaceTagsSubject"
										v-validate="getRule('subject')"
										:inputClasses="[{'is-invalid': fnHasError('subject', 'notification') }]"
										:error=" fnFirstError('subject', 'notification')"
									>
										Assunto
									</MaterialInput>



                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Mensagem</label>
                                    <div class="city-form-group mb-0">
                                         <!-- :class="{'is-invalid': fnHasError('message', 'notification') }" -->
                                        <ckeditor
                                            class="form-control"
                                            v-model="replaceTagsMessage"
                                            :editor="cKEditor.editor"
                                            :config="cKEditor.editorConfig">
                                        </ckeditor>
                                        <input type="hidden" name="message" v-model="form.message" v-validate="getRule('message')">
                                        <small v-if="fnHasError('message', 'notification')" class="d-block invalid-feedback">{{ fnFirstError('message', 'notification') }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-show="activeFilesField" >
                            <div class="col">
                                <!-- {{files}} -->
                                <upload-multiple-file
                                    v-model="files"
                                    :acceptTypes="acceptTypes"
                                    :maxFiles="maxFiles"
                                    name="files"
                                    v-validate="''"
                                    :errorText="fnFirstError('files', 'notification')"
                                />
                            </div>
                        </div>

                        <div class="row pt-sm-3">
                            <div class="col-12">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-12 col-sm-4 order-2 pb-3 pb-sm-0"  v-if="allowCancel">
                                        <button class="btn btn-outline-main btn-rounded btn-md btn-responsive btn-block min-w-auto" type="button" @click.prevent="cancelMessage">{{btnCancelTitle}}</button>
                                    </div>
                                    <div class="col-12 col-sm-4 order-1 order-sm-4 pb-3 pb-sm-0" v-if="allowSend">
                                        <button class="btn btn-main btn-rounded btn-md btn-responsive btn-block min-w-auto" type="button" @click.prevent="sendMessage">{{btnSendTitle}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';
    import mixinGlobal from '@/app/shared/mixins/global';
    import {isArray, arrayDot} from '@config/utils';

    export default {
        name: 'panel-notification',
        components: {
            UploadMultipleFile: () => import(/* webpackChunkName: "upload-file" */ '@/components/form/UploadMultipleFile.vue'),
        },
        mixins: [
            mixinGlobal,
            CkEditorConfigMixin,
        ],
        props: {
            title: {
                type: String,
                required: true,
            },
            show: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            maxFiles: {
                type: Number,
                default: 3,
            },
            mimeTypes: {
                type: Array,
                default: () => ([
                    'application/msword',
                    'application/vnd.ms-excel',
                    'application/vnd.ms-powerpoint',
                    'application/pdf',
                    'image/x-png',
                    'image/jpeg',
                ]),
            },
            acl: {
                type: Object,
                default: () => ({})
            },
            url: {
                type: Object,
                default: () => ({})
            },
            entity: {
                type: [Object],
                required: true,
                default: () => ({})
            }
        },
        data() {
            return {
                idUpload: 'uploadInput',
                buttons: {
                    'send': {'name': 'Enviar', 'active': true},
                    'cancel': {'name': 'Cancelar', 'active': true},
                },
                separatorContacts: ';',
                files: [],
                form: {
                    notification_id: null,
                    channel_id: null,
                    otherTargets: false,
                    contacts: null,
                    subject: null,
                    message: null,
                    targets: [],
                },
                lists: {
                    loaded: false,
                    templates: [],
                    channels: [],
                    targets: [],
                    tags: [],
                    placeholders: [],
                },
            }
        },
        computed: {
            entityId() {
                return this.entity ? this.entity.id : null;
            },
            channel() {
                return this.lists.channels.find(c => c.id == this.form.channel_id);
            },
            channelRules() {
                if(!this.channel) return {};
                const vetRules = this.channel.validation.split(/\r?\n/);
                if(vetRules.length <= 0) return {};
                let rules = {};
                vetRules.forEach(item => {
                    const field = item.replace(/([^:]*).*/, '$1');
                    const rule = item.replace(/[^:]*:(.*)/, '$1');
                    rules[field] = rule;
                });
                return rules;
            },
            activeSubjectField() {
                return this.channel ? (this.channel.fields &&  isArray(this.channel.fields) ? this.channel.fields.includes('subject') : false) : true;
            },
            activeFilesField() {
                return this.channel ? (this.channel.fields &&  isArray(this.channel.fields) ? this.channel.fields.includes('files') : false) : true;
            },
            contacts() {
                let rules = {
                    'required': this.form.otherTargets,
                };

                if(this.channel && this.form.contacts){
                    rules[this.channel.validation] = this.separatorContacts;
                }
                return rules;
            },
            allowSend() {
                return this.buttons['send'].active;
            },
            btnSendTitle () {
                return this.buttons['send'].name;
            },
            allowCancel() {
                return this.buttons['cancel'].active;
            },
            btnCancelTitle () {
                return this.buttons['cancel'].name;
            },
            acceptTypes() {
                return this.mimeTypes.join(', ');
            },
            replaceTagsSubject: {
                get: function() {
                    return this.replaceText(this.form.subject);
                },
                set: function (newValue) {
                    this.form.subject = this.replaceText(newValue);
                }
            },
            replaceTagsMessage: {
                get: function() {
                    return this.replaceText(this.form.message);
                },
                set: function (newValue) {
                    this.form.message = this.replaceText(newValue);
                }
            },
        },
        watch:{
            show: {
                immediate: true,
                handler(val, oldVal) {
                    if(val){
                        this.loadLists();
                    }
                    this.reset();
                },
            },
            activeSubjectField: function(val, oldVal) {
                if(!val) {
                    this.form.subject = null;
                }
            },
            activeFilesField: function(val) {
                if(!val) {
                    this.files = [];
                }
            },
            'form.otherTargets': function(val, oldVal) {
                this.form.emails = '';
            }
        },
        methods: {
            getRule(field) {
                return this.channelRules[field] != undefined ? this.channelRules[field] : '';
            },
            reset: function() {
                Object.assign(this.$data.form, this.$options.data().form);
                Object.assign(this.$data.files, this.$options.data().files);
                this.files = [];
                this.resetValidator();
            },
            loadLists: function() {
                if(!this.lists.loaded){
                    this.$http.get(this.formatUrl(this.url.getNotificationTemplates))
                        .then(res => {
                            let data = res.data ? res.data : res;
                            this.lists.templates = data ? data.data : [];
                            Object.keys(data).forEach(key => {
                                if(key in this.lists) {
                                    this.lists[key] = data[key];
                                }
                            });
                            this.lists.loaded = true;
                            this.setDefaultChannel();
                        })
                        .catch(error => {
                            this.showHttpError(error);
                        });
                }
            },
            setDefaultChannel() {
                if(!this.form.notification_id && this.lists.channels && this.lists.channels.length==1) {
                    this.form.channel_id = this.lists.channels[0].id;
                }
            },
            replacePlaceholder: function(field, name, val) {
                return field.replace(new RegExp(`{{${name}}}`, 'gi'), val || '');
            },
            translatePlaceholder: function(field, name, val) {
                return field.replace(new RegExp(`:${name}`, 'gi'), val || '');
            },
            replaceText: function(field) {
                if(!field || field && field.trim().length==0)
                    return '';

                const entityDot = arrayDot(this.entity);
                let placeholders = this.lists.placeholders;
                this.lists.tags.forEach( (tag, index) => {
                    let tagValue = null;
                    if (typeof this.entity[tag.name] === 'object'){
                        if(this.entity[tag.name] && this.entity[tag.name].name){
                            tagValue = this.entity[tag.name].name;
                        }
                    }else {
                        if(/\./.test(tag.name)) {
                            let altName = tag.name.split('.').slice(1).join('.');
                            if(entityDot[tag.name]) {
                                tagValue = entityDot[tag.name];
                            } else if(entityDot[altName]) {
                                tagValue = entityDot[altName];
                            }
                        } else if (this.entity[tag.name]) {
                            tagValue = this.entity[tag.name];
                        }
                    }
                    if(!tagValue){
                        Object.keys(placeholders).forEach(key => {
                            if(tag.name.toLowerCase() === key.toLowerCase()){
                                if(placeholders[key]){
                                    tagValue = placeholders[key];
                                }
                            }
                        });
                    }

                    if(tagValue == null) {
                        tagValue = ' '
                    }

                    if(tagValue){
                        field = this.replacePlaceholder(field, tag.name, tagValue);
                        field = this.translatePlaceholder(field, tag.name, tagValue);
                    }
                });
                return field;
            },
            onChangeTemplate: function() {
                if(this.form.notification_id) {
                    let idx = this.lists.templates.findIndex(item => item.id == this.form.notification_id);
                    if(idx != -1) {
                        Object.assign(this.$data.form, this.lists.templates[idx]);
                    }
                }else{
                    Object.assign(this.$data.form, this.$options.data().form)
                }
                this.resetValidator();
            },
            cancelMessage: function() {
                this.$emit('canceled');
            },
            sendMessage: function() {
                this.$validator.validateAll('notification')
                .then( result => {
                    if(!result) {
                        this.showError('global.msg.error.form', this.title);
                        return;
                    }

                    if(this.form.message.trim().length == 0) {
                        this.showError('O campo de mensagem deve ser preenchido', this.title);
                        return;
                    }

                    if(this.form.message.length > 0) {
                        let formData = new FormData();
                        for ( var key in this.form.notification ) {
                            formData.append(key, this.form.notification[key]);
                        }
                        formData.append('channel_id', this.form.channel_id ? this.form.channel_id : '');
                        formData.append('notification_id', this.form.notification_id ? this.form.notification_id : '');
                        formData.append('message', this.replaceTagsMessage);
                        formData.append('subject', this.replaceTagsSubject);
                        formData.append('otherTargets', this.form.otherTargets ? 1 : 0);

                        if(this.form.otherTargets) {
                            let contacts = this.form.contacts.split(';').map(item => item.trim());
                            contacts.forEach(contact => {
                                if(contact) {
                                    formData.append('contacts[]', contact);
                                }
                            });
                        }

                        // for (let key in this.form.channels) {
                        //     formData.append('channels[]', this.form.channels[key].id);
                        // }

                        for (let key in this.form.targets) {
                            formData.append('targets[]', this.form.targets[key].id);
                        }

                        formData.delete('files');
                        for (var x = 0; x < this.files.length; x++)
                        {
                            formData.append("files[]", this.files[x].file);
                        }

                        this.$http.post(
                            this.formatUrl(this.url.getSendNotification, {id: this.entityId}),
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        )
                            .then( res => {
                                this.showMessage(res.data.data, this.title);
                                this.$emit('notified');
                            })
                            .catch( error => {
                                this.showHttpError(error);
                            })
                    }

                });
            },
        // fnHasError: function(item, scope="form")
        // {
        //     const fields = scope ? this.fields['$'+scope] : this.fields;
        //     const name = scope ? (scope+'.'+item) : item;
        //     return (fields &&
        //             fields[item] &&
        //             fields[item].dirty &&
        //             !fields[item].valid) || this.errors.has(name);
        // },
        // fnFirstError: function(item, scope="form")
        // {
        //     const name = scope ? (scope+'.'+item) : item;
        //     return this.errors.has(name) ? this.errors.first(name) : null;
        // },
        }
    }
</script>

<style lang="scss" scoped="">
input[type="file"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
}

.uploader-box {
    .delete {
        cursor: pointer;
    }
}

</style>
